import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Box from '../ui/Box';

import NewTelephoneNumber from './NewTelephoneNumber';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; var help = Helper;

export default class TelephoneDirectoryList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      all_numbers: [],
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 20,
      isDemoLogin: false,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  maxItems = 10;
  componentDidMount() {
    this.getAllNumbers(this.state.current_offset);
    window.addEventListener('updateDirectoryTable', (e) => {
      if (e.detail && e.detail == true) {
        this.refreshTable();
      }
    });
  }

  refreshTable(e) {
    this.getAllNumbers(this.state.current_offset - this.maxItems > 0 ? this.state.current_offset - this.maxItems : 0, 1);
  }

  onChangePage(e) {
    this.getAllNumbers(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    });
  }

  getAllNumbers(offset, offset_change = 0) {
    const userData = ls.getUserDetails();
    if (userData.is_demo_user) {
      this.setState({
        isDemoLogin: true
      });

    } else {
      this.setState({
        isDemoLogin: false
      });
    };

    ds.getAllTelephoneNumbers(userData.hotel_id, 10, offset,
      data => {
        this.setState({
          all_numbers: data,
          totalCount: data.length
        });
        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      }, 
      err => {}
    )
  }

  closeDialog(refresh = 0) {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    });
    if (refresh) {
      this.getAllNumbers(0);
    }
  }

  editNumber(row, e) {
    this.setState({
      dialog: {
        open: true,
        body: <NewTelephoneNumber details={row} unMountMe={this.closeDialog.bind(this)} />,
        actions: []
      }
    })
  }

  deleteNumber(row, e) {
    this.setState({
      dialog: {
        open: true,
        head: 'Delete?',
        body: 'Delete Phone number permanently?',
        actions: [
          <FlatButton
            label="Delete"
            primary
            onClick={() => {
              ds.postDeleteTelephoneNumber({ contact_id: row._id },
                data => {
                  let x = this.state.current_offset - this.state.maxItems;
                  this.closeDialog();
                  this.getAllNumbers(x > 0 ? x : 0, 1);
                }, err => {
                  console.log(err);
                });
            }}
          />,
          <FlatButton
            label="Cancel"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    })
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} 
    />
    return (
      <div>
        <Box header='All Phone Numbers'>
          <Dialog
            title={this.state.dialog.head}
            actions={this.state.dialog.actions}
            modal={false}
            open={this.state.dialog.open}
            onRequestClose={this.closeDialog.bind(this)}
          >
            {this.state.dialog.body || 'NA'}
          </Dialog>

          <Table
            height={'45vh'}
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Name">Name</TableHeaderColumn>
                <TableHeaderColumn tooltip="Number">Number</TableHeaderColumn>
                <TableHeaderColumn tooltip="Options">Options</TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              {
                this.state.all_numbers.map((row, index) => (
                  <TableRow key={index}>
                    <TableRowColumn style={{whiteSpace:'normal'}}>{row.name}</TableRowColumn>
                    <TableRowColumn>{row.number}</TableRowColumn>

                    <TableRowColumn>
                      <i className="material-icons link-fg"
                        style={{cursor:'pointer'}}
                        onClick={this.editNumber.bind(this, row)}
                      >
                        mode_edit
                      </i>

                      <i className="space"></i>

                      {
                        this.state.isDemoLogin === false?
                          <i className="material-icons warn-fg"
                            style={{cursor:'pointer'}}
                            onClick={this.deleteNumber.bind(this, row)}
                          >
                            delete
                          </i>
                        : null
                      }
                    </TableRowColumn>
                  </TableRow>
                ))
              }
            </TableBody>

            <TableFooter></TableFooter>
          </Table>
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/telephone/TelephoneDirectoryList.js